import { action, ActionType } from 'typesafe-actions';
import { Language, Money } from '../types/common';

export const CHANGE_LANG = 'APP/CHANGE_LANG';
export const TOKENS_REFRESH = 'APP/TOKENS/REFRESH';
export const TOKENS_REMOVE = 'APP/TOKENS/REMOVE';
export const TOKENS_TOUCH = 'APP/TOKENS/TOUCH';
export const LOGOUT = 'APP/LOGOUT';
export const LOGIN = 'APP/LOGIN';
export const END = 'APP/END';
export const SHOW_AUTH_MODAL = 'AUTH_MODAL/SHOW';
export const HIDE_AUTH_MODAL = 'AUTH_MODAL/HIDE';
export const SHOW_DEPOSIT_MODAL = 'DEPOSIT_MODAL/SHOW';
export const HIDE_DEPOSIT_MODAL = 'DEPOSIT_MODAL/HIDE';
export const SHOW_PASSWORD_RESET_SUCCESS_MODAL = 'PASSWORD_RESET_SUCCESS_MODAL/SHOW';
export const HIDE_PASSWORD_RESET_SUCCESS_MODAL = 'PASSWORD_RESET_SUCCESS_MODAL/HIDE';
export const SHOW_WITHDRAW_MODAL = 'WITHDRAW_MODAL/SHOW';
export const HIDE_WITHDRAW_MODAL = 'WITHDRAW_MODAL/HIDE';
export const SHOW_WITHDRAW_SUBMITTED_MODAL = 'WITHDRAW_SUBMITTED_MODAL/SHOW';
export const HIDE_WITHDRAW_SUBMITTED_MODAL = 'WITHDRAW_SUBMITTED_MODAL/HIDE';
export const TOGGLE_DEPOSIT_SUCCESS_MODAL = 'TOGGLE_DEPOSIT_SUCCESS_MODAL';
export const TOGGLE_SIDEMENU = 'TOGGLE_SIDEMENU';

// @translate
export type AuthModalTab = 'signup' | 'signin' | 'restore';

export type InvestmentSliderSource = 'active' | 'archived' | 'single';

export const actions = {
  changeLanguage: (language: Language) => action(CHANGE_LANG, { language }),
  refreshToken: (accessToken: string, refreshToken: string, userId: string) =>
    action(
      TOKENS_REFRESH,
      {
        accessToken,
        refreshToken,
        userId,
      },
      { ts: Date.now() }
    ),
  removeToken: () => action(TOKENS_REMOVE, undefined, { ts: Date.now() }),
  touchTokens: () => action(TOKENS_TOUCH, undefined, { ts: Date.now() }),
  login: (ops?: { isFirst?: boolean }) => action(LOGIN, ops),
  logout: () => action(LOGOUT),

  showAuthModal: (
    tab: AuthModalTab,
    source: string = 'mainMenu',
    landing: string = 'desktopMainMenuRegistration'
  ) => action(SHOW_AUTH_MODAL, { tab, source, landing }),
  hideAuthModal: () => action(HIDE_AUTH_MODAL),

  showPasswordResetSuccessModal: (email: string) =>
    action(SHOW_PASSWORD_RESET_SUCCESS_MODAL, { email }),
  hidePasswordResetSuccessModal: () => action(HIDE_PASSWORD_RESET_SUCCESS_MODAL),

  showDepositModal: (amount: Money, returnTo?: string) =>
    action(SHOW_DEPOSIT_MODAL, { amount, returnTo }),
  hideDepositModal: () => action(HIDE_DEPOSIT_MODAL),

  showWithdrawModal: (currency?: string) => action(SHOW_WITHDRAW_MODAL, { currency }),
  hideWithdrawModal: () => action(HIDE_WITHDRAW_MODAL),

  toggleDepositSuccessModal: (visible: boolean) =>
    action(TOGGLE_DEPOSIT_SUCCESS_MODAL, { visible }),

  toggleSidemenu: (visible: boolean) => action(TOGGLE_SIDEMENU, { visible }),

  end: () => action(END),
};

export type AppAction = ActionType<typeof actions>;
